<template>
  <div class="breadcrumb-bar">
    <BaseContainer>
      <div class="breadcrumb-bar__wrapper">
        <BaseIcon class="breadcrumb-bar__home" name="home" size="18"></BaseIcon>
        <TextLine class="breadcrumb-bar__link" color="body-light" size="sm">Media Centre</TextLine>
        <BaseIcon class="breadcrumb-bar__icon" name="chevron_right" size="18"></BaseIcon>
        <TextLine class="breadcrumb-bar__text" color="body-light" size="sm">Christmas 2020</TextLine>
        <BaseIcon class="breadcrumb-bar__icon" name="expand_more" size="18"></BaseIcon>
      </div>
    </BaseContainer>
  </div>
</template>

<script>
import TextLine from '../elements/TextLine.vue'
import BaseIcon from '../elements/BaseIcon.vue'
import BaseContainer from '../elements/BaseContainer.vue'
export default {
  name: 'BreadcrumbBar',
  components: { BaseContainer, BaseIcon, TextLine }
}
</script>


<style lang="postcss">
.breadcrumb-bar {
  @apply hidden bg-primary-lightest;
}
.breadcrumb-bar__wrapper {
  @apply flex flex-wrap items-center pt-6 pb-2 text-body-light;
}
.breadcrumb-bar__home {
  @apply ml-0 mr-3 pb-4 cursor-pointer;
}
.breadcrumb-bar__icon {
  @apply mx-3 pb-4;
}
.breadcrumb-bar__link {
  @apply underline pb-4 cursor-pointer;
}
.breadcrumb-bar__link:hover {
  @apply no-underline;
}
.breadcrumb-bar__text {
  @apply pb-4;
}
@screen md {
  .breadcrumb-bar {
    @apply block;
  }
}
</style>
